import React, {useState} from 'react';
import {useTranslation} from "react-i18next";

import css from './DishRightBlockCreateModal.module.css';
import {DishRightBlockInfoModal} from "../DishRightBlockInfoModal/DishRightBlockInfoModal";
import {RecipeForMultiform} from "../../../../ui/RecipeForMultiform/RecipeForMultiform";


const DishRightBlockCreateModal = ({selectedCategory, setSelectedCategory, handleCategoryChange}) => {
    const {t} = useTranslation();
    const [activeTab, setActiveTab] = useState("info");


    return (
        <div className={css.container}>
            <div className={css.tabs}>
                <button
                    className={activeTab === "info" ? css.activeTab : css.tab}
                    onClick={() => setActiveTab("info")}
                    type="button"
                >
                    {t('info')}
                </button>
                <button
                    className={activeTab === "recipe" ? css.activeTab : css.tab}
                    onClick={() => setActiveTab("recipe")}
                    type="button"
                >
                    {t('recipe')}
                </button>
            </div>

            <div className={css.infoBlock}>
                {activeTab === 'info' ? (
                    <div className={css.tabInfoBlock}>
                        <DishRightBlockInfoModal
                            selectedCategory={selectedCategory}
                            setSelectedCategory={setSelectedCategory}
                            handleCategoryChange={handleCategoryChange}
                        />
                    </div>
                ) : (
                    <div className={css.recipeBlock}>
                        <RecipeForMultiform/>
                    </div>
                )}
            </div>
        </div>
    );
};

export {DishRightBlockCreateModal};